module.exports = __webpack_public_path__ + "img/account-auth-logo.d48c7faa.svg";